import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { SectorService } from '../../../@core/services/sector.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { LocationService } from '../../../@core/services/location.service';
import { RouteCompress } from '../../../@core/models/live-route';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { RouteModel } from '../../../@core/models/route';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { CustomerService } from '../../../@core/services/customer.service';

@Component({
  selector: 'ngx-locations-exception',
  templateUrl: './locations-exception.component.html',
  styleUrls: ['./locations-exception.component.scss']
})
export class LocationsExceptionComponent implements OnInit, OnDestroy {
  @ViewChild('content', { static: false }) content;
  public displayedColumns: string[] = ['Postal_Code', 'Route_ID', 'Priority'];
  public digitCount: number = 3;
  showLoading: boolean = false;
  sub: Subscription;
  public customerHoursRangeID: number;
  // public customerIDDest:number = 300668;
  public customerID: number = 0;
  public hourFrom: number = 8;
  public hourTo: number = 12;
  selectedSectorId: number;

  constructor(
    public apiProvider: ApiProvider,
    public _sectorService: SectorService,
    public customerService: CustomerService,
    public toastservice: ToastrService,
    private translate: TranslateService,
    public _locationService: LocationService
  ) {}

  ngOnInit() {
    this._sectorService.initialiseSector();
    this.sub = this._locationService.loadingInProgress.subscribe((data) => {
      this.showLoading = data;
    });
  }

  scrollingPixel:number = 950;
  public scrollRight(): void {
    this.scroll(this.scrollingPixel);
  }

  public scrollLeft(): void {
    this.scroll(-this.scrollingPixel);
  }

  public scroll(postion: number): void {
    this.content.nativeElement.scrollTo({
      left: this.content.nativeElement.scrollLeft + postion,
      behavior: 'smooth'
    });
  }
  
  public selectItem(route: any) {
    this.customerService.initialise(this._sectorService.SectorID).then(() => {
      if(this.customerService.currentValue != null && this.customerService.currentValue.length == 1){
        this.customerID = this.customerService.currentValue[0].CustomerID;
      }
    }
    );
    this.initialiseLocation(route.Route_ID);
  }

  async initialiseLocation(RouteID:number)
  {
    this._locationService.RouteID = RouteID;
    if(this.customerID != 0 && this._locationService.RouteID != null){
      this._locationService.initialiseLocationException(
        this.digitCount,
        this.customerID,
        this.hourFrom,
        this.hourTo
      );
    }
    
  }

  public connectedList: any[];

  getConnectedList(): any[] {
    if (this._sectorService.currentSectorValue != null) {
      this.connectedList = this._sectorService.currentSectorValue.RouteCompress.map(
        (x) => `${x.Route_ID}`
      );
      return this.connectedList.concat(['table']).concat(['tableOnHold']);
    } else {
      return null;
    }
  }

  public updateRouteID(
    PostalCodeDigit: string,
    RouteID: number,
    Priority:number,
    PostalCode: string
  ): void {

    console.log("Priority", Priority);
    this.apiProvider
      .UpdateLocationException(
        this._locationService.RouteID,
        RouteID,
        Priority,
        Priority,
        PostalCodeDigit,
        this.customerID
      )
      .subscribe(() => {
        this._locationService.initialiseLocationException(
          this.digitCount,
          this.customerID,
          this.hourFrom,
          this.hourTo
        );
      });
  }

  public increase(): void {
    this._locationService.setLoadingInProgress(true);
    this.digitCount++;
    this._locationService.initialiseLocationException(
      this.digitCount,
      this.customerID,
      this.hourFrom,
      this.hourTo
    );
  }

  public decrease(): void {
    this._locationService.setLoadingInProgress(true);
    this.digitCount--;
    this._locationService.initialiseLocationException(
      this.digitCount,
      this.customerID,
      this.hourFrom,
      this.hourTo
    );
  }

  public updateLocationException(
    event: any,
    postalCodeDigit: string,
    oldPriority: number
  ): void {
    /* const doneElements = document.querySelectorAll('.loading-submit');
    doneElements.forEach(function(doneItem: HTMLElement) {
      doneItem.style.display = 'none';
    });
    const loading: HTMLElement = document.querySelector(
      '#loading' + PostalCode
    );
    loading.style.display = 'block';
*/

console.log("updateLocationException");
    this.apiProvider
      .UpdateLocationException(
        this._locationService.RouteID,
        this._locationService.RouteID,
        oldPriority,
        Number(event.target.value),
        postalCodeDigit,
        this.customerID
      )
      .subscribe(() => {
        this.toastservice.success(
          this.translate.instant('locations-update.transfert-route'),
          this.translate.instant('Changement effectué'),
          {
            positionClass: 'toast-bottom-left',
            disableTimeOut: false,
            enableHtml: true
          }
        );
      });
  }

  zoomToMap(location: any) {
    location.zoom = 12;
    this._locationService.setLocation(location);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
